(function () {
  'use strict';

  var PHONE_PATTERN = /^[0-9]{10}$/;
  var STORAGE_PREFIX = 'rabitat-pdp-embedded-signup:';
  var CHANNEL = 'whatsapp';

  function sanitizePhone(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 10);
  }

  function validatePhone(value) {
    var phone = sanitizePhone(value);
    if (!phone) return 'Phone number is required.';
    if (!PHONE_PATTERN.test(phone)) return 'Enter a valid 10-digit phone number.';
    return '';
  }

  function setError(el, message) {
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function maskPhone(phone) {
    var digits = sanitizePhone(phone);
    if (digits.length < 4) return '+91 ' + digits;
    return '+91 ' + digits.slice(0, 2) + 'xxxxxx' + digits.slice(-2);
  }

  function submitToGoogleSheet(sheetUrl, payload) {
    if (!sheetUrl) {
      return Promise.reject(new Error('Google Sheet URL is not configured.'));
    }

    var body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      var blob = new Blob([body], { type: 'text/plain;charset=utf-8' });
      if (navigator.sendBeacon(sheetUrl, blob)) {
        return Promise.resolve({ success: true });
      }
    }

    return fetch(sheetUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: body
    }).then(function () {
      return { success: true };
    });
  }

  function storageKey(productId) {
    return STORAGE_PREFIX + String(productId || 'unknown');
  }

  function readStored(productId) {
    try {
      var raw = window.localStorage.getItem(storageKey(productId));
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStored(productId, data) {
    try {
      window.localStorage.setItem(storageKey(productId), JSON.stringify(data));
    } catch (error) {
      /* ignore */
    }
  }

  function clearStored(productId) {
    try {
      window.localStorage.removeItem(storageKey(productId));
    } catch (error) {
      /* ignore */
    }
  }

  var countdownTimerStarted = false;

  function parseCountdownEnd(raw) {
    if (!raw) return NaN;
    var s = String(raw).trim();
    if (!s) return NaN;

    var candidates = [s];

    // e.g. 2026-09-29T023:59:59 → try 02:59:59 and 23:59:59
    var threeHour = s.match(
      /^(\d{4}-\d{2}-\d{2})T(\d{3}):(\d{2}):(\d{2})(\.\d{1,3})?(Z|[+-]\d{2}:?\d{2})?$/i
    );
    if (threeHour) {
      var tail = (threeHour[5] || '') + (threeHour[6] || '');
      candidates.push(threeHour[1] + 'T' + threeHour[2].slice(0, 2) + ':' + threeHour[3] + ':' + threeHour[4] + tail);
      candidates.push(threeHour[1] + 'T' + threeHour[2].slice(1, 3) + ':' + threeHour[3] + ':' + threeHour[4] + tail);
    }

    // Compact time without colons: 2026-09-29T235959
    var compact = s.match(/^(\d{4}-\d{2}-\d{2})T(\d{6})(\.\d{1,3})?(Z|[+-]\d{2}:?\d{2})?$/i);
    if (compact) {
      var t = compact[2];
      var compactTail = (compact[3] || '') + (compact[4] || '');
      candidates.push(
        compact[1] + 'T' + t.slice(0, 2) + ':' + t.slice(2, 4) + ':' + t.slice(4, 6) + compactTail
      );
    }

    // Space instead of T (common in theme editor paste)
    if (s.indexOf(' ') !== -1 && s.indexOf('T') === -1) {
      candidates.push(s.replace(' ', 'T'));
    }

    var seen = {};
    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (seen[candidate]) continue;
      seen[candidate] = true;
      var parsed = Date.parse(candidate);
      if (!Number.isNaN(parsed)) return parsed;
    }

    return NaN;
  }

  function formatCountdown(endIso) {
    var end = parseCountdownEnd(endIso);
    if (Number.isNaN(end)) return '';
    var diff = end - Date.now();
    if (diff <= 0) return 'Sale live now';
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    var secs = Math.floor((diff % 60000) / 1000);
    var parts = [];
    if (days > 0) parts.push(days + 'D');
    parts.push(hours + 'H');
    parts.push(mins + 'M');
    parts.push(secs + 'S');
    return 'Sale Starts In ' + parts.join(' ');
  }

  function updateAllCountdowns() {
    document.querySelectorAll('[data-rabitat-pdp-embedded-signup]').forEach(function (root) {
      var endIso = root.getAttribute('data-countdown-end');
      var wrap = root.querySelector('[data-embedded-countdown]');
      var textEl = root.querySelector('[data-embedded-countdown-text]');
      if (!endIso || !wrap || !textEl) return;

      var label = formatCountdown(endIso);
      if (!label) {
        wrap.hidden = true;
        return;
      }
      textEl.textContent = label;
      wrap.hidden = false;
    });
  }

  function startCountdownTimer() {
    if (countdownTimerStarted) return;
    countdownTimerStarted = true;
    window.setInterval(updateAllCountdowns, 1000);
  }

  function applyTemplate(tpl, vars) {
    return String(tpl || '')
      .replace(/\{contact\}/g, vars.contact || '')
      .replace(/\{price\}/g, vars.price || '')
      .replace(/\{product\}/g, vars.product || '');
  }

  function getPayload(root) {
    return {
      product_id: root.getAttribute('data-product-id') || '',
      product_title: root.getAttribute('data-product-title') || '',
      product_handle: root.getAttribute('data-product-handle') || '',
      variant_id: root.getAttribute('data-variant-id') || '',
      variant_name: root.getAttribute('data-variant-name') || '',
      variant_price: root.getAttribute('data-offer-price') || ''
    };
  }

  function setBerlinFormSubmittedHash() {
    try {
      var path = window.location.pathname + window.location.search + '#berlin-form-submitted';
      window.history.replaceState(null, '', path);
    } catch (error) {
      window.location.hash = 'berlin-form-submitted';
    }
  }

  function syncSuccessToAll(productId, contactDisplay) {
    document.querySelectorAll('[data-rabitat-pdp-embedded-signup]').forEach(function (node) {
      if (String(node.getAttribute('data-product-id')) !== String(productId)) return;
      showSuccessView(node, contactDisplay);
    });
  }

  function showSuccessView(root, contactDisplay) {
    var formView = root.querySelector('[data-embedded-form-view]');
    var successView = root.querySelector('[data-embedded-success-view]');
    var bodyEl = root.querySelector('[data-embedded-success-body]');
    if (!successView || !bodyEl) return;

    var tpl = root.getAttribute('data-success-whatsapp') || '';
    var price = root.getAttribute('data-offer-price') || '';
    var product = root.getAttribute('data-product-short') || root.getAttribute('data-product-title') || '';

    bodyEl.textContent = applyTemplate(tpl, {
      contact: contactDisplay,
      price: price,
      product: product
    });

    if (formView) {
      formView.hidden = true;
      formView.setAttribute('hidden', '');
    }
    successView.hidden = false;
    successView.removeAttribute('hidden');
  }

  function updateSubmitEnabled(root) {
    var phoneInput = root.querySelector('[data-embedded-phone]');
    var submitBtn = root.querySelector('[data-embedded-submit]');
    if (!submitBtn) return;
    if (submitBtn.getAttribute('aria-busy') === 'true') return;

    var phone = phoneInput ? sanitizePhone(phoneInput.value) : '';
    submitBtn.disabled = !PHONE_PATTERN.test(phone);
  }

  function resetFormView(root) {
    var form = root.querySelector('[data-embedded-signup-form]');
    var formView = root.querySelector('[data-embedded-form-view]');
    var successView = root.querySelector('[data-embedded-success-view]');
    if (form) form.reset();
    setError(root.querySelector('[data-embedded-phone-error]'), '');
    setError(root.querySelector('[data-embedded-form-error]'), '');
    if (formView) {
      formView.hidden = false;
      formView.removeAttribute('hidden');
    }
    if (successView) {
      successView.hidden = true;
      successView.setAttribute('hidden', '');
    }
    var submitBtn = root.querySelector('[data-embedded-submit]');
    if (submitBtn) {
      submitBtn.removeAttribute('aria-busy');
    }
    updateSubmitEnabled(root);
  }

  function updateVariantMeta(root, variant) {
    if (!variant) return;
    root.setAttribute('data-variant-id', String(variant.id || ''));
    root.setAttribute('data-variant-name', variant.name || variant.title || '');
  }

  function bindRoot(root) {
    if (!root || root.dataset.embeddedSignupBound === 'true') return;
    root.dataset.embeddedSignupBound = 'true';

    var productId = root.getAttribute('data-product-id');
    var sheetUrl = root.getAttribute('data-google-sheet-url') || '';

    var stored = readStored(productId);
    if (stored && stored.submitted) {
      showSuccessView(root, stored.contactDisplay);
    }

    var phoneInput = root.querySelector('[data-embedded-phone]');
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        phoneInput.value = sanitizePhone(phoneInput.value);
        setError(root.querySelector('[data-embedded-phone-error]'), '');
        updateSubmitEnabled(root);
      });
    }

    updateSubmitEnabled(root);

    var changeBtn = root.querySelector('[data-embedded-change-contact]');
    if (changeBtn) {
      changeBtn.addEventListener('click', function () {
        clearStored(productId);
        document.querySelectorAll('[data-rabitat-pdp-embedded-signup]').forEach(function (node) {
          if (String(node.getAttribute('data-product-id')) === String(productId)) {
            resetFormView(node);
          }
        });
      });
    }

    var form = root.querySelector('[data-embedded-signup-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var formError = root.querySelector('[data-embedded-form-error]');
        setError(formError, '');

        var phone = phoneInput ? sanitizePhone(phoneInput.value) : '';
        var phoneErr = validatePhone(phone);
        setError(root.querySelector('[data-embedded-phone-error]'), phoneErr);
        if (phoneErr) return;

        var contactDisplay = maskPhone(phone);

        if (!sheetUrl) {
          setError(formError, 'Sign-up is not configured. Please try again later.');
          return;
        }

        var submitBtn = root.querySelector('[data-embedded-submit]');
        var metaLeadEventId = submitBtn ? submitBtn.getAttribute('data-meta-lead-event-id') || '' : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        var base = getPayload(root);
        var submission = {
          timestamp: new Date().toISOString(),
          email: '',
          phone: phone,
          notification_channel: CHANNEL,
          product_id: base.product_id,
          product_title: base.product_title,
          product_handle: base.product_handle,
          variant_id: base.variant_id,
          variant_name: base.variant_name,
          variant_price: base.variant_price,
          page_url: window.location.href,
          signup_source: 'pdp_embedded',
          meta_lead_event_id: metaLeadEventId,
          event_id: metaLeadEventId
        };

        writeStored(productId, {
          submitted: true,
          channel: CHANNEL,
          contactDisplay: contactDisplay
        });

        setBerlinFormSubmittedHash();
        syncSuccessToAll(productId, contactDisplay);

        submitToGoogleSheet(sheetUrl, submission).catch(function (error) {
          console.warn('Rabitat embedded signup sheet sync failed:', error);
        });
      });
    }
  }

  function initAll() {
    startCountdownTimer();
    updateAllCountdowns();
    document.querySelectorAll('[data-rabitat-pdp-embedded-signup]').forEach(bindRoot);
  }

  document.addEventListener('rabitat:variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-rabitat-pdp-embedded-signup]').forEach(function (root) {
      updateVariantMeta(root, variant);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
